export const sampleDoctorData = [
  {
    id: "DOC-001",
    title: "Dr.",
    firstName: "John",
    lastName: "Smith",
    email: "john.smith@hospital.com",
    phone: "(555) 123-4567",
    department: "Cardiology",
    specialization: "Interventional Cardiology",
    licenseNumber: "MD123456789",
    npiNumber: "1234567890",
    employmentStatus: "Full-time",
    hireDate: "2020-01-15",
    status: "Active",
    emergencyPrivileges: true,
    languages: ["English", "Spanish"],
    clinicLocations: ["Main Campus", "Downtown Clinic"],
    workSchedule: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
  },
  {
    id: "DOC-002",
    title: "Dr.",
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@hospital.com",
    phone: "(555) 234-5678",
    department: "Pediatrics",
    specialization: "Pediatric Oncology",
    licenseNumber: "MD987654321",
    npiNumber: "0987654321",
    employmentStatus: "Full-time",
    hireDate: "2018-03-20",
    status: "Active",
    emergencyPrivileges: false,
    languages: ["English", "French"],
    clinicLocations: ["Main Campus"],
    workSchedule: ["Monday", "Tuesday", "Wednesday", "Thursday"],
  },
  {
    id: "DOC-003",
    title: "Dr.",
    firstName: "Michael",
    lastName: "Chen",
    email: "michael.chen@hospital.com",
    phone: "(555) 345-6789",
    department: "Emergency Medicine",
    specialization: "Emergency Medicine",
    licenseNumber: "MD456789123",
    npiNumber: "4567891230",
    employmentStatus: "Part-time",
    hireDate: "2021-06-10",
    status: "Active",
    emergencyPrivileges: true,
    languages: ["English", "Chinese (Mandarin)"],
    clinicLocations: ["Emergency Department"],
    workSchedule: ["Saturday", "Sunday", "Night Shift"],
  },
  {
    id: "DOC-004",
    title: "Dr.",
    firstName: "Emily",
    lastName: "Davis",
    email: "emily.davis@hospital.com",
    phone: "(555) 456-7890",
    department: "Neurology",
    specialization: "Stroke Medicine",
    licenseNumber: "MD789123456",
    npiNumber: "7891234560",
    employmentStatus: "Full-time",
    hireDate: "2019-09-05",
    status: "On Leave",
    emergencyPrivileges: false,
    languages: ["English"],
    clinicLocations: ["Main Campus", "North Branch"],
    workSchedule: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
  },
  {
    id: "DOC-005",
    title: "Dr.",
    firstName: "Robert",
    lastName: "Wilson",
    email: "robert.wilson@hospital.com",
    phone: "(555) 567-8901",
    department: "Surgery",
    specialization: "Orthopedic Surgery",
    licenseNumber: "MD321654987",
    npiNumber: "3216549870",
    employmentStatus: "Full-time",
    hireDate: "2017-11-30",
    status: "Active",
    emergencyPrivileges: true,
    languages: ["English", "German"],
    clinicLocations: ["Surgical Center", "Main Campus"],
    workSchedule: ["Tuesday", "Wednesday", "Thursday", "Friday"],
  },
];
